export default "__VITE_ASSET__BzOFSBdb__"